import React from 'react';
export var Clock = function Clock() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "9",
    r: "8",
    stroke: "inherit",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5L8.5 9.5L12.5 9.5",
    stroke: "inherit",
    fill: "none"
  }));
};